import { useEffect, useState } from "react";
import BackendCategoryAPI from "../../api/backend/category";

import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";

const CategorySelect = (props) => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        BackendCategoryAPI.all()
            .then((r) => {
                setList(() => r.data);
            })
            .finally(() => setLoading(() => false));
    }, []);

    return (
        <InputGroup>
            <Form.Select value={props.value} onChange={props.onChange} disabled={props.disabled}>
                {!props.hideOptionAll && <option value="">ทั้งหมด</option>}
                <option value="0">ไม่มีหมวดหมู่</option>
                {list.map((v, i) => (
                    <option key={i} value={v.id}>
                        {v.name}
                    </option>
                ))}
            </Form.Select>

            {loading && (
                <InputGroup.Text>
                    <Spinner animation="border" role="status" size="sm">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </InputGroup.Text>
            )}
        </InputGroup>
    );
};

export default CategorySelect;
